module.exports = __webpack_public_path__ + "img/low-fat-chicken-enchiladas.eb735e99.jpg";